const backendURL = import.meta.env.VITE_API_URL;

// Obtener todos los servicios
export const getAllServices = async (user) => {
    try {
        const response = await fetch(`${backendURL}/services`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${user.token}`,
            },
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return await response.json();
    } catch (error) {
        throw error;
    }
};

// Obtener servicios por compañía
export const getServicesByCompany = async (companyId, user) => {
    const response = await fetch(`${backendURL}/services/company/${companyId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${user?.token || ''}`,
        },
    }).catch(() => null); // Silencia errores de red

    if (!response) return []; // Si falló el fetch
    if (response.status === 404) return []; // Si no existen servicios
    if (!response.ok) return []; // Para otros códigos de error

    const data = await response.json().catch(() => ({}));
    return Array.isArray(data) ? data : [];
};


export const getServiceById = async (serviceId, user) => {
    try {
        const response = await fetch(`${backendURL}/services/${serviceId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${user.token}`,
            },
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return await response.json();
    } catch (error) {
        throw error;
    }
};

export const createService = async (serviceData, photoFile, user) => {
    try {
       
        if (!serviceData.title || !serviceData.description) {
            throw new Error('Title and description are required');
        }

        const formData = new FormData();

        
        const servicePayload = {
            title: serviceData.title,
            description: serviceData.description,
            type_publish: serviceData.type_publish,
            type_service: serviceData.type_service,
            category: serviceData.category,
            date_publish: serviceData.date_publish,
            contact: serviceData.contact || '',
            status: 'active', 
            company_rut: user.rut, 
            email: serviceData.email || user.email || '',
            location: serviceData.location || '',
            visits: 0, 
            name_contact: serviceData.name_contact || '',
        };

      
        Object.entries(servicePayload).forEach(([key, value]) => {
            formData.append(key, value);
        });

      
        if (photoFile) {
            formData.append('image', photoFile);
        }

       

        const response = await fetch(`${backendURL}/services`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${user.token}`,
            },
            body: formData,
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => null);
            throw new Error(errorData?.message || `HTTP error! status: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error creating service:', error);
        throw new Error(error.message || 'Failed to create service');
    }
};
// Actualizar un servicio
export const updateService = async (serviceId, updateData, user) => {
   
    try {
        const response = await fetch(`${backendURL}/services/${serviceId}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${user.token}`,
            },
            body: JSON.stringify(updateData),
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return await response.json();
    } catch (error) {
        throw error;
    }
};


export const updateServiceWithPhoto = async (serviceId, updateData, photoFile, user) => {
    try {
        
        if (!serviceId) throw new Error('Service ID is required');
        if (!user?.token) throw new Error('User token is missing');

        const formData = new FormData();

       
        Object.entries(updateData).forEach(([key, value]) => {
            if (value !== undefined && value !== null && key !== 'company_rut' && key !== 'visits') {
                
                const finalValue = value instanceof Date ? value.toISOString() : value;
                formData.append(key, finalValue);
            }
        });

        
        if (photoFile) {
            formData.append('image', photoFile); 
        }

     
       

        const response = await fetch(`${backendURL}/services/${serviceId}`, {
            method: 'PATCH',
            headers: {
                'Authorization': `Bearer ${user.token}`,
                
            },
            body: formData,
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(
                errorData.message || 
                `Error ${response.status}: ${response.statusText}`,
            );
        }

        return await response.json();
    } catch (error) {
        console.error('Error en updateServiceWithPhoto:', {
            error: error.message,
            serviceId,
            updateData: Object.keys(updateData), // Solo mostramos las claves por privacidad
            user: user ? { id: user.id } : null
        });
        throw new Error(error.message || 'Failed to update service');
    }
};

// Eliminar un servicio
export const deleteService = async (serviceId, user) => {
    try {
        
        if (!serviceId) {
            throw new Error('Service ID is required');
        }
        if (!user?.token) {
            throw new Error('User authentication token is missing');
        }

        const response = await fetch(`${backendURL}/services/${serviceId}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${user.token}`,
                // No incluir 'Content-Type' para solicitudes DELETE sin body
            },
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({
                message: `Failed to delete service (Status: ${response.status})`
            }));
            
            throw new Error(
                errorData.message || 
                errorData.error || 
                `Request failed with status ${response.status}`
            );
        }

    
        const textResponse = await response.text();
        return textResponse ? JSON.parse(textResponse) : { success: true };

    } catch (error) {
        console.error('Error deleting service:', {
            serviceId,
            error: error.message,
            user: user ? { id: user.id } : null,
            timestamp: new Date().toISOString()
        });
        
        throw new Error(
            error.message || 
            'An unexpected error occurred while deleting the service'
        );
    }
};
// Actualizar visitas de un servicio
export const updateServiceVisits = async (serviceId, user) => {
    try {
        const response = await fetch(`${backendURL}/services/${serviceId}/visits`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${user.token}`,
            },
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return await response.json();
    } catch (error) {
        throw error;
    }
};


export const uploadServicePhoto = async (serviceId, photoFile, user) => {
    try {
        const formData = new FormData();
        formData.append('photo', photoFile);

        const response = await fetch(`${backendURL}/services/${serviceId}/photo`, {
            method: 'POST',
            headers: {
                'authorization': `Bearer ${user.token}`,
            },
            body: formData,
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return await response.json();
    } catch (error) {
        throw error;
    }
};

// Eliminar foto de un servicio
export const deleteServicePhoto = async (serviceId, user) => {
    try {
        const response = await fetch(`${backendURL}/services/${serviceId}/photo`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${user.token}`,
            },
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return await response.json();
    } catch (error) {
        throw error;
    }
};